import { connect } from 'react-redux';
import get from 'lodash/get';

import { getAMLSCommonNotifications } from '../../../../redux/actions/common';
import NotificationsDropdown from './dropdown';

function mapStateToProps(state) {
  return {
    authentication: state.authentication,
    notifications: get(state, 'amlsCommon.commonNotifications.data', []),
    notificationsApiStatus: get(
      state,
      'amlsCommon.commonNotifications.isLoading',
      false
    )
  };
}

function mapDispatchToProps(dispatch) {
  return {
    getAMLSCommonNotifications: () => {
      dispatch(getAMLSCommonNotifications());
    }
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(NotificationsDropdown);
